/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Stanard Report page
  Date: June 25, 2020
**/

import React from 'react';
import { Grid } from '@material-ui/core';
import {
  CustomReportResult,
  CustomStandardReportResult
} from '../../components';

const ReportResultPage = (props) => {

  const checkReportType = () => {
    if (props.match.params.reporttype === 'custom') {
      return (
        <CustomReportResult
          reportType={props.match.params.reporttype}
          reportID={props.match.params.id}
          history={props.history}
        />
      );
    }else{
      return (
        <CustomStandardReportResult
          reportType={props.match.params.reporttype}
          reportID={props.match.params.id}
          history={props.history}
        />
      );
    }

  };

  return (
    <Grid container direction="row" style={{ backgroundColor: '#fff' }}>
      {checkReportType()}
    </Grid>
  );
};

export default ReportResultPage;
